const reflinks = {
  reflinks: 'Рефссылки администратора',
  showing: 'показывается',
  reflinksOf: 'рефссылки',
  noReflinksFound: 'Рефссылки не найдены',
  addNew: 'Добавить новую',
  tableDropdown: {
    quickActions: 'Быстрые действия',
    refresh: 'Обновить',
    exportReflinks: 'Экспортировать',
  },
  actionsDropdown: {
    update: 'Обновить',
    delete: 'Удалить',
  },
  modal: {
    addNewReflink: 'Добавить новую рефссылку',
    email: 'Электронная почта',
    name: 'Имя',
    code: 'Код',
    category: 'Категория',
    bonus: 'Бонус',
    editReflink: 'Изменить рефссылку',
  },
  messages: {
    success: 'Новая рефссылка создана.',
    updateSuccess: 'Рефссылка сохранена.',
    deleteSuccess: 'Рефссылка удалена.',
  }
};
export default reflinks;
